export function ArrowsTransformSparkleIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9997 1.99976L22.0005 8.97396L20.0005 8.97419L20.0001 5.41386L18.0001 7.41405L16.5858 5.99989L18.5857 3.99988L15 4.00001L15 2.00001L21.9997 1.99976ZM12.7094 12.7094L14.0513 8.68374H15.9487L17.2906 12.7094L21.3162 14.0513V15.9487L17.2906 17.2905L15.9487 21.3162H14.0513L12.7094 17.2905L8.68377 15.9487V14.0513L12.7094 12.7094ZM15 12.1622L14.4487 13.8162L13.8162 14.4487L12.1623 15L13.8162 15.5513L14.4487 16.1837L15 17.8377L15.5513 16.1837L16.1838 15.5513L17.8377 15L16.1838 14.4487L15.5513 13.8162L15 12.1622ZM3.99989 15.0256L4.0003 18.5859L6.00034 16.5857L7.41461 17.9999L5.41475 19.9999L9.00039 19.9997L9.00047 21.9997L2.0007 22L1.99989 15.0258L3.99989 15.0256Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.15066 6.15062L6.93079 3.81023H8.06921L8.84934 6.15062L11.1897 6.93076V8.06918L8.84934 8.84931L8.06921 11.1897H6.93079L6.15066 8.84931L3.81026 8.06918V6.93076L6.15066 6.15062Z"
        fill="currentColor"
      />
    </svg>
  );
}
